<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>{{navigationTitle}}</h4>
      <el-button
        size="small"
        type="info"
        @click="backProject"
      >返回项目列表</el-button>
    </div>
    <el-card class="box-card">
      <!-- 这里边是一个表单 -->
      <el-form
        ref="reference"
        :model="reference"
        size="small"
        label-width="80px"
        label-position="top"
        :rules="rules"
      >
        <el-form-item
          label="项目名称"
          prop="name"
        >
          <el-col>
            <el-input
              type="textarea"
              v-model="reference.name"
              placeholder="请输入项目名称"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          label="申办方"
          prop="sponsor"
        >
          <el-col :span="9">
            <el-input
              v-model="reference.sponsor"
              placeholder="请输入申办方名称"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          label="联系人"
          prop="contacts"
        >
          <el-col :span="5">
            <el-input
              v-model="reference.contacts"
              placeholder="请输入联系人"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          label="联系方式"
          prop="phone"
        >
          <el-col :span="5">
            <el-input
              v-model="reference.phone"
              placeholder="请输入联系方式"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="email"
        >
          <el-col :span="9">
            <el-input
              v-model="reference.email"
              placeholder="请输入邮箱"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="微信号">
          <el-col :span="7">
            <el-input
              v-model="reference.wechat"
              placeholder="请输入微信号"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="reference.remarks"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="background: #484c7f"
            @click="submitForm('reference')"
          >保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 

<script>
export default {
  name: 'editorProject',
  data () {
    return {
      navigationTitle: '添加项目',
      reference: {
        //?  表单字段
        name: '',//项目名称
        sponsor: '',//申办方 
        contacts: '',//联系人
        phone: '',//联系电话
        wechat: '',//微信号
        email: '',//邮箱
        remarks: '',//备注
        id: '',//有id是修改 无id是新增 
      },
      rules: {
        name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        sponsor: [
          { required: true, message: '请输入申办方名称', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ],
      }
    }
  },
  created () {
    this.reference.id = this.$route.query.id
    if (this.reference.id != "") this.compileEntry(this.$route.query.id)
  },
  methods: {
    //点击编辑进来的
    async compileEntry (id) {
      this.navigationTitle = '编辑项目'
      const { data: data } = await this.$http.post('project/detail', {
        id
      })
      this.reference = data.data
    },
    //返回
    backProject () {
      this.$router.back()
    },
    //提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitApi()
        } else {
          return false;
        }
      });
    },
    //提交接口
    async submitApi () {
      const { data: data } = await this.$http.post('project/add', this.reference)
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.backProject()
    },
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .box-card {
    width: 100%;
    flex: 1;
    //overflow-y: auto;
  }
  /deep/ .el-card {
    overflow: visible;
  }
}
</style>
